<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex no-print" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Apotik" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan. Pastikan tidak ada nilai negatif pada embalase dan tuslah, jumlah diskon tidak lebih dari 100% atau lebih dari subtotal serta pastikan jumlah lebih dari 0',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div style="position: relative">
            <div class="d-flex flex-between my-3">
              <h5 class="mb-2">Resep Obat / Alkes</h5>
            </div>
            <div
              class="form-group"
              v-if="
                !ringkasan || (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
              "
            >
              <div class="input-group">
                <input
                  type="text"
                  :class="
                    'form-control form-control-lg pl-5 with-icon-left without-label ' +
                      (isError ? 'error' : '')
                  "
                  placeholder="Cari kode atau nama obat di sini"
                  @input="
                    (e) => {
                      a_obat = false;
                      s_obat = e.target.value;
                      updateForm();
                    }
                  "
                  :value="s_obat"
                  v-on:keyup.enter="() => search('obat')"
                />
                <i
                  class="material-symbols-outlined"
                  style="margin-top: -0.25rem"
                  >search</i
                >
                <div class="input-group-append">
                  <button
                    class="btn btn-secondary btn-with-icon-left"
                    @click="() => search('obat')"
                  >
                    <i class="material-symbols-outlined">search</i>
                    CARI
                  </button>
                </div>
              </div>
            </div>
            <SearchResult
              type=""
              @addItem="(item) => addItem(item, 'obat')"
              v-if="s_obat && a_obat"
              :loading="l_obat"
              :data="r_obat"
            />
            <table v-if="obat.length" class="responsive">
              <thead>
                <th>KODE / NAMA BARANG /<br />JENIS OBAT / GOLONGAN OBAT</th>
                <!-- <th>LOKASI</th> -->
                <th>HARGA / JUMLAH</th>
                <th>EMBALASE / TUSLAH</th>
                <th>DISKON</th>
                <th>ATURAN PAKAI</th>
                <th>SUB TOTAL</th>
                <th
                  v-if="
                    !ringkasan ||
                      (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                  "
                ></th>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in obat"
                  v-bind:key="item.id + Math.random(1024)"
                  v-show="!item.deleted"
                >
                  <td>
                    {{ item.kode }} / {{ item.nama }} / <br />
                    {{ item.jenis }} /
                    {{ item.golongan_obat }}
                  </td>
                  <!-- <td>{{ item.lokasi }}</td> -->
                  <td>
                    {{ item.formatted_harga }}
                    <br />
                    <br />
                    <InputNumber
                      @handleChange="(e) => handleChange(e)"
                      :value="item.jumlah"
                      :input="{ class: 'inline', name: 'jumlah-' + index }"
                      v-if="
                        !ringkasan ||
                          (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                      "
                    />
                    <div v-else>{{ item.jumlah }} satuan</div>
                  </td>
                  <td>
                    <InputMoney
                      @handleChange="(e) => handleChange(e)"
                      :value="item.embalase"
                      :input="{
                        class: 'group-inline',
                        name: 'embalase-' + index,
                      }"
                      v-if="
                        !ringkasan ||
                          (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                      "
                    />
                    <div v-else>
                      {{ convertToRupiah(item.embalase) }}
                    </div>
                    <br />
                    <InputMoney
                      @handleChange="(e) => handleChange(e)"
                      :value="item.tuslah"
                      :input="{
                        class: 'group-inline',
                        name: 'tuslah-' + index,
                      }"
                      v-if="
                        !ringkasan ||
                          (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                      "
                    />
                    <div v-else>
                      {{ convertToRupiah(item.embalase) }}
                    </div>
                  </td>
                  <td>
                    <Select
                      :input="{
                        class: 'inline',
                        name: 'diskon_type-' + index,
                        options: tipeDiskonOptions,
                      }"
                      :value="item.diskon_type"
                      @handleChange="(e) => handleChange(e)"
                      v-if="
                        !ringkasan ||
                          (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                      "
                    />
                    <br
                      v-if="
                        !ringkasan ||
                          (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                      "
                    />
                    <InputPercentage
                      @handleChange="(e) => handleChange(e)"
                      v-show="item.diskon_type == 'Percentage'"
                      :value="item.diskon"
                      :input="{
                        class: 'group-inline',
                        name: 'diskon-' + index,
                      }"
                      v-if="
                        !ringkasan ||
                          (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                      "
                    />
                    <div v-else>
                      {{
                        item.diskon_type == "Percentage"
                          ? item.diskon + "%"
                          : convertToRupiah(item.diskon)
                      }}
                    </div>
                    <InputMoney
                      @handleChange="(e) => handleChange(e)"
                      :value="item.diskon"
                      v-show="item.diskon_type == 'Rp' || !item.diskon_type"
                      :input="{
                        class: 'group-inline',
                        name: 'diskon-' + index,
                      }"
                      v-if="
                        !ringkasan ||
                          (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                      "
                    />
                  </td>
                  <td>
                    <Select
                      :input="{
                        class: 'inline',
                        name: 'catatan_dokter-' + index,
                        options: aturanPakaiOptions,
                      }"
                      :value="item.catatan_dokter"
                      @handleChange="(e) => handleChange(e)"
                      v-if="
                        !ringkasan ||
                          (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                      "
                    />
                    <div v-else>
                      {{ item.catatan_dokter }}
                    </div>
                  </td>
                  <td>{{ convertToRupiah(item.sub_total) }}</td>
                  <td
                    v-if="
                      !ringkasan ||
                        (ringkasan && ringkasan.status == 'BELUM DIBAYAR')
                    "
                  >
                    <button
                      class="btn btn-icon btn-danger btn-sm"
                      @click="() => deleteItem('obat', item.id)"
                    >
                      <i class="material-symbols-outlined">delete</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="card px-4 py-3 mb-2 mt-3" v-if="ringkasan">
            <div class="row mb-3">
              <div class="col-md-3 offset-md-9">
                <span
                  :class="
                    `badge badge-${
                      ringkasan && ringkasan.status == 'BELUM DIBAYAR'
                        ? 'danger'
                        : ringkasan.status == 'BELUM LUNAS'
                        ? 'warning'
                        : 'primary'
                    } block`
                  "
                  >{{ ringkasan.status }}</span
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 offset-md-6">
                <!-- <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Nomor Pembayaran</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0">
                          {{
                            ringkasan
                              ? ringkasan.no_pembayaran
                              : ""
                          }}
                        </h4>
                      </div>
                    </div> -->
                <!-- <hr /> -->
                <div class="row mb-3">
                  <div class="col-md-6">
                    <h4 class="mb-0 text-muted">Total Pembayaran</h4>
                  </div>
                  <div class="col-md-6">
                    <h4 class="mb-0 text-right">
                      {{
                        ringkasan
                          ? convertToRupiah(ringkasan.total_bayar)
                          : "Rp 0"
                      }}
                    </h4>
                  </div>
                </div>
                <hr />
                <h4
                  class="text-muted"
                  v-if="!ringkasan || (ringkasan && !ringkasan.diskon)"
                >
                  Diskon
                </h4>
                <div
                  class="row mb-3 d-flex top"
                  v-if="!ringkasan || (ringkasan && !ringkasan.diskon)"
                >
                  <div class="col-md-12">
                    <FormRow
                      v-for="row in diskonForm"
                      v-bind:key="row.colnum + String(Math.random(1023))"
                      :row="row"
                      :flexStart="true"
                      @handleChange="(e) => handleChangeDiskon(e)"
                    />
                  </div>
                </div>
                <div class="row mb-3" v-else>
                  <div class="col-md-6">
                    <h4 class="mb-0 text-muted">Diskon</h4>
                  </div>
                  <div class="col-md-6">
                    <h4 class="mb-0 text-secondary text-right">
                      {{
                        ringkasan ? convertToRupiah(ringkasan.diskon) : "Rp 0"
                      }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card px-4 py-3 mb-2 mt-3" v-else>
            <div class="row">
              <div class="col-md-6 offset-md-6">
                <div class="row mb-3">
                  <div class="col-md-6">
                    <h4 class="mb-0 text-muted">Total Pembayaran</h4>
                  </div>
                  <div class="col-md-6">
                    <h4 class="mb-0 text-right">
                      {{ convertToRupiah(total_bayar) }}
                    </h4>
                  </div>
                </div>

                <hr />
                <h4 class="text-muted">Diskon</h4>
                <div class="row mb-3 d-flex top">
                  <div class="col-md-12">
                    <FormRow
                      v-for="row in diskonForm"
                      v-bind:key="row.colnum + String(Math.random(1023))"
                      :row="row"
                      :flexStart="true"
                      @handleChange="(e) => handleChangeDiskon(e)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row"
              v-if="
                ringkasan &&
                  !(ringkasan.status == 'LUNAS' || ringkasan.sisa_tagihan == 0)
              "
            >
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  {{ lunas ? "LUNASI PEMBAYARAN" : "BAYAR" }}
                </button>
                <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/kasir">Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => reset('/apotik')"
                  >Batalkan</a
                >
              </div>
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="print"
                  class="
                    btn btn-secondary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">print</i>
                  Simpan dan Cetak Resep Obat
                </button>
                <button
                  @click="() => handleForm(false, false)"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Resep Obat
                </button>
                <!-- <router-link
                  class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                  to="/apotik"
                >Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => reset('/apotik')"
                  >Batalkan</a
                >
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
    <div class="only-print px-3">
      <div class="row">
        <div
          class="col-md-4 px-0"
          style=""
          v-for="item in obat"
          v-bind:key="item.id + item.kode + Math.random(1024)"
        >
          <div class="card" style="height: 100%">
            <div class="card-body">
              <p class="mb-1">Nama: {{ detailTop.title }}</p>
              <small
                >{{ item.kode }}/ {{ item.jenis }} /
                {{ item.golongan_obat }}</small
              >
              <h5>{{ item.nama }}</h5>
              <span>{{ item.catatan_dokter }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import SearchResult from "@/components/SearchResult.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import InputMoney from "@/components/InputMoney.vue";
import InputPercentage from "@/components/InputPercentage.vue";
import InputNumber from "@/components/InputNumber.vue";
import Select from "@/components/Select.vue";
import {
  setPatientIntro,
  setRawatIntro,
  convertToRupiah,
  discounted,
  formatDiscount,
  tipeDiskonOptions,
  resetForms,
  aturanPakaiOptions,
} from "@/data/helper.js";
//console.log(discounted);
//console.log(formatDiscount);
// import { HTTP,HTTP_ENC } from "@/config.js";
import { diskonForm } from "@/data/KasirForm.js";
import { data } from "@/data/ApotikDetail.js";

export default {
  name: "ApotikDetail",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    DetailLeft,
    DetailRight,
    InputMoney,
    InputNumber,
    InputPercentage,
    Alert,
    SearchResult,
    Select,
    FormRow,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      aturanPakaiOptions: aturanPakaiOptions,
      tipeDiskonOptions: tipeDiskonOptions,
      data: data,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      ringkasan: null,
      id_ringkasan: null,
      formSet: {
        no_rawat: "",
      },
      diskonForm: diskonForm,
      formSetDiskon: {
        diskon_type: "Rp",
        diskon: "",
      },
      n: 0,
      s_obat: "",
      r_obat: [],
      obat: [],
      a_obat: false,
      l_obat: false,
      isError: false,
      jumlah: [],
      embalase: [],
      tuslah: [],
      convertToRupiah: convertToRupiah,
      total_bayar: 0,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    fetchRingkasan: async function(reinit) {
      try {
        let result;
        result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${this.id_ringkasan}`
        );
        // if (this.$route.query.id_ringkasan) {
        //   result = await this.$store.state.HTTP.get(
        //     `menu/kasir/tagihan_ringkasan/${this.$route.query.id_ringkasan}`
        //   );
        // } else {
        //   result = await this.$store.state.HTTP.post(
        //     `menu/kasir/tagihan_ringkasan_by_no_rawat?no_rawat=${this.formSet["no_rawat"]}`
        //   );
        // }

        //console.log("tagihan ringkasan");
        //console.log(result);
        //console.log("tagihan ringkasan");

        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          this.no_rawat = result.data.no_rawat;
          //this.id_asuransi = result.data.id_asuransi;
          this.ringkasan = result.data;
          //console.log("//ringkasan");
          //console.log(this.ringkasan);
          //console.log("//ringkasan");
          this.diskonForm[0].columns[1].max = this.ringkasan?.sisa_tagihan;
          //console.log(this.ralan);
          if (!this.ralan) {
            this.ralan = await this.$store.state.HTTP.get(
              `ralan/${this.id_ralan}`
            );
            //console.log(this.ralan);
            //console.log("ya dapet");
            if (this.ralan?.data?.pasien?.asuransi_lain) {
              //console.log("masuk euy");
              this.asuransiLain = await this.$store.state.HTTP.get(
                `asuransi_lain/${this.ralan.data.pasien.asuransi_lain}`
              );
              if (this.asuransiLain && this.asuransiLain.status == "200") {
                this.ralan.data.pasien.asuransi.nama += `: ${this.asuransiLain?.data?.nama}`;
                //console.log("this ralan");
                //console.log(this.ralan);
                //console.log("this ralan");
              }
            }
            //console.log(this.ralan);
          }
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    print: async function() {
      await this.handleForm(true, true);
    },
    validateFormDiskon: function() {
      let valid = true;
      let self = this;
      //console.log("============validateFormDiskon");
      //console.log(self.formSetDiskon);
      //console.log("============validateFormDiskon");
      //console.log(this.diskonForm);
      // return;
      this.diskonForm = this.diskonForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSetDiskon[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              column.max &&
              parseFloat(self.formSetDiskon[column.name]) >
                parseFloat(column.max)
            ) {
              valid = false;
              column.error = "Nilai tidak boleh lebih dari " + column.max;
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSetDiskon[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai tidak boleh negatif";
            } else {
              column.error = "";
            }
          }
          if (self.formSetDiskon[column.name]) {
            column.value = self.formSetDiskon[column.name];
          }
          return column;
        });
        return row;
      });
      return valid;
    },
    handleFormDiskon: async function() {
      ////console.log(this.formSetDiskon.no_rm);
      this.errors = [];
      let formData = new FormData();
      formData.append("no_rawat", this.formSet.no_rawat);
      var self = this;
      let valid = this.validateFormDiskon();
      //console.log("store diskon");
      if (valid) {
        Object.keys(this.formSetDiskon).forEach(function(key) {
          formData.append(key, self.formSetDiskon[key]);
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "menu/kasir/store-diskon",
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.init();
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        ////console.log("tidak valid");
      }
      //console.log("store diskon");
    },
    handleForm: async function(print, redirect) {
      this.saveFailed = false;
      this.saveSuccess = false;
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        self.n = this.obat.filter(
          (item) => !(item.deleted && !item.id_ralan_obat)
        ).length;
        let obats =
          this.obat && this.obat.length
            ? this.obat
                .filter((item) => !(item.deleted && !item.id_ralan_obat))
                .map((item) => {
                  return {
                    operation: item.deleted ? "delete" : null,
                    no_rawat: self.formSet["no_rawat"],
                    id_obat: item.id,
                    embalase: item.embalase,
                    golongan_obat: item.golongan_obat,
                    tuslah: item.tuslah,
                    jumlah: item.jumlah,
                    sub_total: item.sub_total,
                    catatan_dokter: item.catatan_dokter,
                    diskon_type: item.diskon_type || "Rp",
                    diskon: item.diskon,
                    ranap_obat: item.ranap_obat ? item.ranap_obat : 0,
                  };
                })
            : [];
        //console.log(obats);
        if (obats && obats.length) {
          obats.forEach((item) => {
            if (item.diskon_type == "Percentage") {
              if (parseFloat(item.diskon) > 100) {
                this.saveFailed = true;
                this.saveSuccess = false;
                this.checkSuccess(print, redirect);
                return;
              }
            } else {
              if (parseFloat(item.diskon) > parseFloat(item.sub_total)) {
                this.saveFailed = true;
                this.saveSuccess = false;
                this.checkSuccess(print, redirect);
                return;
              }
            }
            //console.log({ type: item.diskon_type, diskon: item.diskon });
          });
          if (this.saveFailed) {
            return;
          }
          try {
            let result = await this.$store.state.HTTP_JSON.post(
              `ralan/resep/obat-bulk`,
              { obats }
            );
            //console.log("---------- hasil save");
            //console.log(result);
            //console.log("---------- hasil save");
            if (!result || result.status != 200) {
              this.saveFailed = true;
              this.saveSuccess = false;
              this.checkSuccess(print, redirect);
              return;
            } else {
              //console.log(result.data);
              this.id_ringkasan = result.data.tagihan_ringkasan.id;
              if (this.formSetDiskon.diskon) {
                await this.handleFormDiskon();
              }
              this.checkSuccess(print, redirect);
            }
          } catch (e) {
            //console.log(e);
            this.saveFailed = true;
            this.saveSuccess = false;
            this.checkSuccess(print, redirect);
            return;
          }
        }
        // this.checkSuccess(print,redirect);
      } else {
        this.saveFailed = true;
        this.saveSuccess = false;
        this.checkSuccess(print, redirect);
      }
    },
    handleFormOld: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        self.n = this.obat.filter(
          (item) => !(item.deleted && !item.id_ralan_obat)
        ).length;

        this.obat.forEach(async function(item) {
          //n-=1;
          if (!item.deleted) {
            let body = `no_rawat=${self.formSet["no_rawat"]}&id_obat=${item.id}&harga=${item.harga}&jumlah=${item.jumlah}&embalase=${item.embalase}&tuslah=${item.tuslah}&sub_total=${item.sub_total}`;
            if (!item.id_ralan_obat) {
              await self.saveData(body);
            } else {
              await self.saveData(body, item.id_ralan_obat);
            }
          } else {
            if (item.id_ralan_obat) {
              await self.deleteData(item.id_ralan_obat);
            }
          }
        });
      } else {
        //console.log(valid);
      }
    },
    async saveData(body, id) {
      try {
        if (id) {
          let result = await this.$store.state.HTTP_ENC.put(
            `ralan/resep/obat/${id}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess(print);
            }
          }
        } else {
          let result = await this.$store.state.HTTP_ENC.post(
            `ralan/resep/obat`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess(print);
            }
          }
        }
      } catch (e) {
        ////console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async deleteData(id) {
      try {
        let result = await this.$store.state.HTTP_ENC.delete(
          `ralan/resep/obat/${id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess(print);
          }
        }
      } catch (e) {
        ////console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async checkSuccess(print, redirect) {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          if (redirect) {
            // that.$router.push(`/ralan/detail/${that.$route.params.id}`);
            that.reset(`/apotik`);
          }
          if (print) {
            window.print();
          }
          that.init();
        }, 1000);
      }
    },
    handleChangeDiskon(e) {
      this.formSetDiskon[e.target.name] = e.target.value;
      if (e.target.name == "diskon_type") {
        if (e.target.value == "Rp") {
          this.diskonForm[0].columns[1].value = "";
          this.diskonForm[0].columns[1].type = "money";
          if (
            this.ringkasan &&
            this.ringkasan.all_tagihan_count &&
            this.ringkasan.all_tagihan_count.sisa_tagihan
          ) {
            this.diskonForm[0].columns[1].max = this.ringkasan.all_tagihan_count.sisa_tagihan;
          }
        } else {
          this.diskonForm[0].columns[1].value = "";
          this.diskonForm[0].columns[1].type = "percentage";
          this.diskonForm[0].columns[1].max = 100;
        }
      }
      if (e.target.name == "diskon_type") {
        this.diskonForm[0].columns[0].value = this.formSetDiskon[e.target.name];
        //console.log(this.formSetDiskon);
      }
    },
    handleChange(e) {
      // if (e.target.type == "file") {
      //   if(e.target.files && e.target.files.length) { this.formSet[e.target.name] = e.target.files[0]; }
      // } else {
      //   this.formSet[e.target.name] = e.target.value;
      // }
      let name = e.target.name.split("-")[0];
      let index = e.target.name.split("-")[1];
      if (e.target.type == "number") {
        this.obat[index][name] = parseFloat(e.target.value || 0);
      } else {
        this.obat[index][name] = e.target.value;
      }
      let diskon = 0;
      this.obat[index]["sub_total"] =
        this.obat[index].jumlah * this.obat[index].harga +
        this.obat[index].embalase +
        this.obat[index].tuslah;
      if (this.obat[index]["diskon"]) {
        if (this.obat[index]["diskon_type"] == "Percentage") {
          diskon =
            (parseFloat(this.obat[index]["diskon"]) / 100) *
            parseFloat(this.obat[index]["sub_total"]);
        } else {
          diskon = parseFloat(this.obat[index]["diskon"]);
        }
      }
      this.obat[index]["sub_total"] -= diskon;
      this.obat.splice(index, 1, this.obat[index]);

      //console.log(this.obat[index][name]);

      //console.log(this.obat[index]);
      // this.updateForm();
      this.updateTotal();
    },
    updateTotal() {
      if (!this.ringkasan) {
        this.total_bayar = 0;
        this.obat.forEach((item) => {
          this.total_bayar += item.sub_total;
        });
        //console.log(this.total_bayar);
      } else {
        this.ringkasan.total_bayar = 0;
        this.obat.forEach((item) => {
          this.ringkasan.total_bayar += item.sub_total;
        });

        this.ringkasan.sisa_tagihan =
          this.ringkasan.total_bayar -
          (this.ringkasan.ditanggung || 0) -
          (this.ringkasan.diskon || 0) -
          (this.ringkasan.dibayar || 0);
      }
    },
    updateForm() {
      // this.obatForm[0].columns[0].value=String(this.formSet['id_petugas']);
      // this.obatForm[0].columns[1].value=String(this.formSet['id_dokter']);
      // this.labForm[0].columns[0].value=String(this.formSet['id_petugas_lab']);
      // this.labForm[0].columns[1].value=this.formSet['lab_type'];
    },
    validateForm: function() {
      let valid = true;
      // let self = this;
      this.obat.forEach((item) => {
        if (
          parseInt(item.jumlah) < 1 ||
          parseInt(item.embalase) < 0 ||
          parseInt(item.tuslah) < 0
        ) {
          valid = false;
          return;
        }
      });
      return valid;
    },
    fetchData: async function() {
      //console.log(result);
      if (this.obat.length) {
        let nObat = this.obat.length;
        for (var i = 0; i < nObat; i++) {
          this.obat.pop();
        }
      }
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/resep/obat?per_page=9999999999&no_rawat=${this.formSet["no_rawat"]}`
        );
        let self = this;
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_obat = item.id;
            item.id = item.obat.id;
            item.kode = item.obat.kode;
            item.nama = item.obat.nama;
            item.jenis = item.obat.jenis;
            item.lokasi = item.obat.lokasi;
            item.golongan_obat = item.obat.golongan_obat;
            item.diskon_type = item.diskon_type || "Rp";
            self.obat.push(item);
          });
          self.obat = self.obat.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          // if(result.data.length){
          //   self.formSet.id_petugas_lab=String(result.data[0].id_petugas);
          //   labForm[0].columns[0].value=self.formSet.id_petugas_lab;
          //   self.formSet.lab_type=result.data[0].kategori;
          //   labForm[0].columns[1].value=self.formSet.lab_type;
          // }
          //console.log(self['formSet']);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    search: async function(type) {
      //console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;

      let url;
      if (type == "lab") {
        url = "periksalab";
      } else {
        url = "obat";
      }
      try {
        let result = await this.$store.state.HTTP.get(
          `${url}?per_page=9999999999&q=${this["s_" + type]}`
        );
        //console.log(result);
        if (result.status == "200") {
          // this['r_'+type]=result.data;
          let self = this;
          this["r_" + type] = result.data.map(function(item) {
            item.formatted_diskon = formatDiscount(
              item.tipe_diskon,
              item.diskon
            );
            item.harga_awal = item.harga;
            item.harga = discounted(
              parseInt(item.harga),
              item.tipe_diskon,
              parseFloat(item.diskon)
            );
            item.formatted_harga = self.convertToRupiah(item.harga);
            //console.log(item);
            return item;
          });
          //console.log(this['r_'+type]);
          self["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          self["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      if (!this[type].find((el) => el.id == item.id)) {
        item.jumlah = 1;
        item.embalase = 0;
        item.tuslah = 0;
        item.sub_total = item.harga;
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      //console.log(this[type]);
      this.updateTotal();
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      this.updateTotal();
      //console.log(this[type]);
    },
    init: async function() {
      try {
        // let result = await this.$store.state.HTTP.get(`ralan/tebus/obat/${this.$route.params.id}`);
        let result = await this.$store.state.HTTP.get(
          `ralan/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log('ralan');
          //console.log(result.data);
          this.detailTop = setPatientIntro(result.data.pasien);
          //console.log(this.detailTop);
          let detailRawat = setRawatIntro(result.data);
          this.detailLeftTop = detailRawat.detailLeftTop;
          this.detailRightTop = detailRawat.detailRightTop;
          //console.log('ralan');
          this.formSet["no_rawat"] = result.data.no_rawat;
          //console.log(this.formSet['no_rawat']);
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
      await this.fetchData();
      await this.fetchRingkasan();
    },
    reset(url, stay) {
      // if (this.validated) {
      resetForms(
        this.formSetDiskon,
        [this.diskonForm],
        true,
        this.handleChangeDiskon
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = "?tab=" + fromTab;

          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    handlePopstate(event) {
      console.log("going in");
      this.reset(`/apotik`, false, true);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.id_ringkasan = this.$route.query.id_ringkasan;
    this.data.toReset = (url) => this.reset(url);
    await this.init();
  },
  created() {
    window.addEventListener("popstate", (event) => this.handlePopstate(event));
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("popstate", (event) =>
      this.handlePopstate(event)
    );
    next();
  },
};
</script>
